import fetch from 'isomorphic-fetch';
import * as userActions from '../actions/user';

const URL_PREFIX = ''; // @see ... webpackConfig, there is a proxydefinition - TODO ... define url in webpackconfig

export function getConfiguratorData(documentId) {
    return fetch(URL_PREFIX + `/api/document/` + documentId, {
        credentials: 'include', // @see ... https://www.npmjs.com/package/whatwg-fetch - sending cookies
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    });
}

export function getCampaignGroups() {
    return fetch(URL_PREFIX + `/api/campaignsgroups`, {
        credentials: 'include',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
}

export function getDocumentStorages() {
    return fetch(URL_PREFIX + `/api/documentstorage`, {
        credentials: 'include',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
}

export function getOrganisationUsers() {
  return fetch(URL_PREFIX + `/api/organizationuser`, {
    credentials: 'include',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  })
}

export function createDocumentStorage(title, documentId, locale, pricingField) {
    return fetch(URL_PREFIX + `/api/documentstorage`, {
        credentials: 'include',
        method: 'POST',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            title: title,
            documentId: documentId,
            locale: locale,
            pricingField: pricingField
        })
    })
}

export function deleteDocumentStorage(id) {
    return fetch(URL_PREFIX + `/api/documentstorage/` + id, {
        credentials: 'include',
        method: 'DELETE',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
}

export function updateDocumentStorage(id, title = null, documentId = null, documentValues = null, memo=null, authorId=null) {

    let requestBody = {
        id: id
    };

    if (title !== null) {
        requestBody.title = title;
    }
    if (documentId !== null) {
        requestBody.documentId = documentId;
    }
    if (documentValues !== null) {
        requestBody.documentValues = documentValues;
    }
    if (memo !== null) {
        requestBody.memo = memo;
    }
    if (authorId !== null) {
        requestBody.authorId = authorId;
    }

    return fetch(URL_PREFIX + `/api/documentstorage`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)
    })
}

export function copyDocumentStorage(sourceStorageId, newTitle, newLocale) {

    let requestBody = {
        documentStorageId: sourceStorageId,
        title: newTitle,
        locale: newLocale
    };

    return fetch(URL_PREFIX + `/api/documentstorage/copy`, {
        credentials: 'include',
        method: 'POST',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)
    })
}

export function login(username, password, locale) {
    return fetch(URL_PREFIX + `/` + locale + `/login_check`, {
        credentials: 'include',
        method: 'POST',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            _username: username,
            _password: password
        })
    })
}

export function getUserStatus() {
    return fetch(URL_PREFIX + `/api/user`, {
        credentials: 'include',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
}

export function logout(locale) {
    return fetch(URL_PREFIX + `/` + locale + `/logout`, {
        credentials: 'include',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
}

export function handleStatus(response, dispatch) {
    if (response.status >= 500) {
        alert('An unexpected API error!');
        const error = new Error(response.statusText);
        error.response = response;
        throw error;
    }
    else if (response.status == 403) {
        dispatch(userActions.loginRequired());
        const error = new Error(response.statusText);
        error.response = response;
        throw error;
    } else if (response.status == 400) {
        const error = new Error(response.statusText);
        error.response = response;
        throw error;
    }
    return response.json()
}

export function handleError(response) {

}

export function getAppConfig() {
    return fetch(URL_PREFIX + `/api/configuration`, {
        credentials: 'include',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
}

export function getCart() {
    return fetch(URL_PREFIX + `/api/shoppingcart`, {
        credentials: 'include',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
}

export function updateCartItem(documentStorageId, quantity) {

    let requestBody = {
        documentStorageId: documentStorageId,
        quantity: quantity
    };

    return fetch(URL_PREFIX + `/api/shoppingcart`, {
        credentials: 'include',
        method: 'POST',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)
    })
}

export function requestApproval(documentStorageId) {

    let requestBody = {
        id: documentStorageId
    };

    return fetch(URL_PREFIX + `/api/documentstorage/request-approval`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)
    })
}

export function processCart(cartData) {

    let mappedData = {
        billingAddressIsDeliveryAddress: !cartData.otherBillingAddress
    };
    let requestBody = {...cartData, ...mappedData};

    console.log('REQUEST BODY CART', requestBody);

    return fetch(URL_PREFIX + `/api/process-shoppingcart`, {
        credentials: 'include',
        method: 'POST',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)

    })
}

export function getImageUpload(id) {
    return fetch(URL_PREFIX + `/api/imageupload/` + id, {
        credentials: 'include',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
}

export function deleteImageUpload(id) {
    return fetch(URL_PREFIX + `/api/imageupload/` + id, {
        credentials: 'include',
        method: 'DELETE',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
}



// WEBPACK FOOTER //
// ./src/js/api/api.js